if(!customElements.get('free-gift')) {
  customElements.define('free-gift', class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.variantId = parseInt(this.dataset.variantId);
      this.isProductAvailable = this.dataset.isProductAvailable === 'true';
      if(!this.isProductAvailable) return;


      const refreshCartDrawer = () => {
        const cartItems = document.querySelector('cart-drawer-items');
        cartItems.onCartUpdate();
      }


    const addFreeGiftToCart = async () => {
        const formData = {
            "items": [
                {
                    "id": this.variantId,
                    "quantity": 1,
                }
            ]
        }

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        });
        await response.json();

        refreshCartDrawer();
    }

    const removeFreeGiftFromCart = async () => {
        const formData = {
                    "id": this.variantId,
                    "quantity": 0
                }

        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        });
        const freeGiftData = await response.json();

        refreshCartDrawer();
    }

    const normalizeFreeGiftQuantityToOne = async () => {
        const formData = {
            "id": this.variantId.toString(),
            "quantity": 1
        };

        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        await response.json();

        refreshCartDrawer();
    };
    
    let isFlaggedForUpdate = false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
        if(isFlaggedForUpdate) return;
        isFlaggedForUpdate = true;

        try{
            const cartData = await fetch('/cart.js').then(response => response.json());

            const isAnySellingPlanInCart = cartData.items.some(item => item.selling_plan_allocation);
            const freeGiftIndex = cartData.items.findIndex(item => item.variant_id === this.variantId);
            const isFreeGiftInCart = freeGiftIndex !== -1;
            const freeGiftItem = isFreeGiftInCart ? cartData.items[freeGiftIndex] : null;

            if(isAnySellingPlanInCart && !isFreeGiftInCart) {
                await addFreeGiftToCart();
            } else if (!isAnySellingPlanInCart && isFreeGiftInCart) {
                // find line item index of free gift
                const freeGiftLineItemIndex = cartData.items.findIndex(item => item.variant_id === this.variantId) + 1;

                // click remove button if it exists
                const removeButton = document.querySelector(`cart-remove-button[data-index="${freeGiftLineItemIndex}"]`);
                if(removeButton) {
                    removeButton?.click();
                } else{
                    // if remove button does not exist, remove free gift from cart
                    await removeFreeGiftFromCart();
                }
            } else if (isAnySellingPlanInCart && isFreeGiftInCart && freeGiftItem && freeGiftItem.quantity !== 1) {
                // if any selling plan is in cart and free gift is in cart and quantity is not 1, normalize quantity to 1
                await normalizeFreeGiftQuantityToOne();
              } else {
                return;
            }

        } catch (error) {
            console.error('Error fetching cart data:', error);
        } finally {
            isFlaggedForUpdate = false;
        }
    });
    }
  });
}
